import React from 'react';
import {TransitionContainer, NeuroMessage} from "@ignitesales/neuro-application";
import {useDialogueContext} from "../../../../../../shared/js";

const PageMessage = () => {
    const { getPagePathMessageId } = useDialogueContext();
    const messageId = getPagePathMessageId();
    const componentClass = "pageMessage";

    return <div className={componentClass}>
        <TransitionContainer className="sidebarTransitionContainer" transitionKey={messageId}>
            <NeuroMessage id={messageId} tagName="h4" shouldHideIfNotFound={true} />
        </TransitionContainer>
    </div>};

export default PageMessage;
